// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aC","left":"aD","center":"aE","right":"aF"};